import { useAppSelector } from "@/redux/store/hooks";
import { Box, Heading, HTMLWrapper } from "@/storybook-components";

const AboutPlaces = () => {
  const {
    name = "",
    description = ""
  }: { name?: string; description?: string } = useAppSelector(
    (state) => state.place.place
  );

  return (
    <Box
      className="ehq-projectDescriptionContainer"
      maxHeight={{ sm: "40svh", md: "40svh", lg: "40svh" }}
      height={{ lg: "19.875rem" }}
      overflowY="auto"
      tabIndex={0}
    >
      <Heading as="h1" pb={8}>
        {name}
      </Heading>
      <Box>
        <HTMLWrapper html={description}></HTMLWrapper>
      </Box>
    </Box>
  );
};

export default AboutPlaces;
